import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { writeClassReducer,  WRITE_CLASS_SAGAS } from './WriteClass';
import createSagaMiddleware from 'redux-saga'
import { all } from 'redux-saga/effects'
import {
    adminReducer,
    ADMIN_SAGAS
} from './Admin';
import createRavenMiddleware from 'raven-for-redux';
import Raven from 'raven-js';
import {
    get
} from 'lodash';

function* rootSaga() {
    yield all([
        ADMIN_SAGAS,
        WRITE_CLASS_SAGAS,
    ])
}

const reducers = combineReducers({
    write_class: writeClassReducer,
    admin: adminReducer,
});

const sagaMiddleware = createSagaMiddleware({
    onError: (e) => {
        alert('Sorry! We ran into an error. This occurence has been logged. Please try refreshing the page')
        Raven.captureException(e);
    }
})

let ravenMiddleware;
const ravenEnabled = (process.env.REACT_APP_RAVEN_ENABLED.toLowerCase() === 'true');
if (ravenEnabled) {
    Raven.config(process.env.REACT_APP_RAVEN_DSN).install();
    ravenMiddleware = createRavenMiddleware(Raven, {
        environment: process.env.REACT_APP_RAVEN_ENVIRONMENT,
        getUserContext: (state) => ({
            id: get(state, ['write_class', 'user', 'id'])  // add user ID for Sentry tracking
        }),
    });
}

const appStore = createStore(
    reducers,
    undefined,
    compose(
        applyMiddleware(sagaMiddleware),
        ravenEnabled ? applyMiddleware(ravenMiddleware) : fn => fn,
        (process.env.NODE_ENV !== 'production' && window.__REDUX_DEVTOOLS_EXTENSION__) ? window.__REDUX_DEVTOOLS_EXTENSION__() : fn => fn
    )
);

sagaMiddleware.run(rootSaga)

export default appStore;



// WEBPACK FOOTER //
// ./src/store/index.js